(function() {
  'use strict';

  function initSkuCopy() {
    const copyButtons = document.querySelectorAll('.js-sku-copy-btn:not([data-sku-copy-initialized])');
    
    copyButtons.forEach(button => {
      // Mark as initialized to avoid duplicate listeners
      button.setAttribute('data-sku-copy-initialized', 'true');
      
      if (navigator.clipboard && navigator.clipboard.writeText) {
        button.addEventListener('click', copySku, true);
        button.addEventListener('touchstart', function(e) {
          e.stopPropagation();
        }, { passive: true, capture: true });
        button.addEventListener('mousedown', function(e) {
          e.stopPropagation();
        }, true);
      } else {
        button.style.display = 'none';
      }
    });
  }

  function copySku(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
    
    const button = event ? event.currentTarget : event.target;
    const skuContainer = button.closest('.card__sku');
    const skuText = skuContainer ? skuContainer.querySelector('.js-sku-text') : null;
    
    if (!skuText) return false;
    
    const sku = skuText.textContent.trim();
    
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(sku).then(
        () => {
          showCopySuccess(button);
        },
        () => {
          fallbackCopy(sku);
          showCopySuccess(button);
        }
      );
    } else {
      fallbackCopy(sku);
      showCopySuccess(button);
    }
    
    return false;
  }

  function showCopySuccess(button) {
    const copyIcon = button.querySelector('.card__sku-copy-icon');
    const successIcon = button.querySelector('.card__sku-copy-success');
    
    if (copyIcon && successIcon) {
      copyIcon.style.display = 'none';
      successIcon.style.display = 'inline-flex';
    }
    
    setTimeout(() => {
      if (copyIcon && successIcon) {
        copyIcon.style.display = 'inline-flex';
        successIcon.style.display = 'none';
      }
    }, 2000);
  }

  function fallbackCopy(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
      document.body.removeChild(textArea);
    } catch (err) {
      console.error('Failed to copy SKU:', err);
      document.body.removeChild(textArea);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSkuCopy);
  } else {
    initSkuCopy();
  }

  const observer = new MutationObserver(function(mutations) {
    let shouldInit = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.classList.contains('card__sku') || node.querySelector('.card__sku'))) {
            shouldInit = true;
          }
        });
      }
    });
    if (shouldInit) {
      initSkuCopy();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  } else {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

